import { useMemo } from 'react';
import { NumericFormat } from 'react-number-format';
import { STANDARD_INSURANCE_DOMAIN_PREFIX } from '../../enums/prefix';
import { useSelector } from 'react-redux';

interface CurrencyFormatterProps {
    value: number | string;
    prefix?: boolean;
    suffix?: boolean;
    thousandSeparator?: boolean | string;
    decimalScale?: number;
    fixedDecimalScale?: boolean;
    displayType?: "text" | "input";
    className?: string;
    prefixSymbol?: string;
    suffixSymbol?: string;
    [key: string]: any
}

interface CurrencyConfig {
    prefix: string;
    suffix: string;
}

export const CURRENCY_DEFAULTS: { [key: string]: CurrencyConfig } = {
    // "localhost": {
    //     prefix: "ETB ",
    //     suffix: "ETB",
    // },
    [STANDARD_INSURANCE_DOMAIN_PREFIX]: {
        prefix: "ETB ",
        suffix: "ETB",
    },
};

export default function CurrencyFormatter({
    value,
    prefix,
    prefixSymbol,
    suffix,
    suffixSymbol,
    thousandSeparator = true,
    decimalScale = 2,
    fixedDecimalScale = true,
    displayType = "text",
    className,
    ...otherProps
}: CurrencyFormatterProps) {
    const tenantCreds = useSelector((state: any) => state.tenantCreds);

    const pFix = tenantCreds?.currency?.prefix ?? "KES";
    const sFix = tenantCreds?.currency?.suffix ?? "Ksh";

    const finalPrefix = useMemo(() => {
        if (prefixSymbol) return `${prefixSymbol} `;
        if (prefix) return `${pFix} `;
    }, [prefix, prefixSymbol, pFix]);

    const finalSuffix = useMemo(() => {
        if (suffixSymbol) return ` ${suffixSymbol}`;
        if (suffix) return ` ${sFix}`;
    }, [suffix, suffixSymbol, sFix]);

    return (
        <NumericFormat
            value={value}
            displayType={displayType}
            prefix={finalPrefix}
            suffix={finalSuffix}
            thousandSeparator={thousandSeparator}
            decimalScale={decimalScale}
            fixedDecimalScale={fixedDecimalScale}
            className={className}
            {...otherProps}
        />
    )
}